import { createContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const AuthContext = createContext({});
